<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="inherit"
        stroke="none"
        stroke-width=".2"
        d="M19.2 19.3h.1V4.7H4.7v14.6h14.5ZM4.8 3.1h14.4a1.7 1.7 0 0 1 1.7 1.7v14.4a1.7 1.7 0 0 1-1.7 1.7H4.8a1.7 1.7 0 0 1-1.7-1.7V4.8a1.7 1.7 0 0 1 1.7-1.7Z"
      />
      <rect width="6" height="6" x="9" y="9" fill="inherit" stroke="none" rx="1" />
    </svg>
  </span>
</template>
